import React from 'react';
import { useSelector } from 'react-redux';
import { ensureBackgroundForForeground } from '~/modules/Helper/contrast.helper';
import * as S from './Title.styled';

/** Hangul filler / espaços usados como “título vazio” no cadastro. */
function tituloVisivel(titulo) {
  if (titulo == null) return '';
  return String(titulo)
    .replace(/\u3164/g, '')
    .replace(/\u00a0/g, ' ')
    .trim();
}

function Title() {
  const configuration = useSelector(state => state.configuration);
  const { corTema, titulo, highContrast } = configuration;
  const texto = tituloVisivel(titulo);

  if (!texto) {
    return null;
  }

  // Mesmas cores do menu: fundo do tema (AA p/ texto branco) + texto #fff
  const background = highContrast
    ? '#000000'
    : ensureBackgroundForForeground(corTema || '#036f5a');
  const color = highContrast ? '#ffff00' : '#ffffff';

  return (
    <S.Title color={color} background={background}>
      {texto}
    </S.Title>
  );
}

export default Title;
